import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkAllowPresentContent } from 'features/permissions/actions';

export function* bulkAllowPresentContentSaga(action: ReturnType<typeof bulkAllowPresentContent>) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk allowed present content for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkAllowPresentContent',
    data: { roles },
  });
}
